import React, { useEffect, useState } from "react";
import Preview from "../../common/resumePreview/preview";
import { getDetails } from "./services";

function ResumeShare() {
  //http://localhost:3001/resumeshare?loginId =1234556
  let query: any = window.location.href;
  let urlParams: any = new URL(query);
  let loginId: any = urlParams.searchParams.get("loginId");

  const [allData, setAllData] = useState<any>();

  useEffect(() => {
    //   const loginId = localStorage.getItem('loginId')
    getCandidateDetails(loginId);
  }, []);

  const getCandidateDetails = (loginId: string | null) => {
    getDetails(loginId).then((response) => {
      if (response.status === 1) {
        setAllData(response.data[0].profile_metadata);
      }
    });
  };

  return (
    <div>
      <Preview showSubmit={false} candaidateData={allData} />
    </div>
  );
}

export default ResumeShare;
